// Central asset registry for the NTOA landing page.
// Editable copy/pricing/links live in ./content.js
export { LINKS } from "./content";

export const IMAGES = {
  logo: "/ntoa-logo.png?v=2",
  hero:
    "https://static.prod-images.emergentagent.com/jobs/76e553f1-cc56-4968-b52b-03456a24e6c5/images/449711d2fb3238a5d4b1cbef20cb104acaffe983eb323f09f67074d71bccf1bc.jpeg",
  driverPortrait:
    "https://static.prod-images.emergentagent.com/jobs/76e553f1-cc56-4968-b52b-03456a24e6c5/images/21e502a9c0c57d2f436aca74f3c5d10b2001b8828b180c13df2b1482b7690805.jpeg",
  aerialHighway:
    "https://images.unsplash.com/photo-1564668836804-05a2de350bb6?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  fleetWarehouse:
    "https://images.unsplash.com/photo-1778015862504-b877b548266e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxmcmVpZ2h0JTIwdHJ1Y2tzJTIwZmxlZXQlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzgzNzM5NTI2fDA&ixlib=rb-4.1.0&q=80&w=1200",
  sunsetTruck:
    "https://images.pexels.com/photos/35602229/pexels-photo-35602229.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  roadTrees:
    "https://images.unsplash.com/photo-1564668836804-05a2de350bb6?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
};
